export const affiliateConstants = {
  SET_AFFILIATE_LOADING: 'affiliate/SET_AFFILIATE_LOADING',
  GET_AFFILIATE_INVITES: 'affiliate/GET_AFFILIATE_INVITES',
  SET_AFFILIATE_INVITES: 'affiliate/SET_AFFILIATE_INVITES',
  CLEAR_AFFILIATE_INVITES: 'affiliate/CLEAR_AFFILIATE_INVITES',
  EXPORT_AFFILIATE_INVITES: 'affiliate/EXPORT_AFFILIATE_INVITES',

  SET_AFFILIATE_SETTINGS_LOADING: 'affiliate/SET_AFFILIATE_SETTINGS_LOADING',
  GET_AFFILIATE_SETTINGS: 'affiliate/GET_AFFILIATE_SETTINGS',
  SET_AFFILIATE_SETTINGS: 'affiliate/SET_AFFILIATE_SETTINGS',
  UPDATE_AFFILIATE_SETTINGS: 'affiliate/UPDATE_AFFILIATE_SETTINGS',
  SET_AFFILIATE_SETTINGS_SAVING: 'affiliate/SET_AFFILIATE_SETTINGS_SAVING',
};
